import {
    LISTE_CATEGORIE_FAIL,
    LISTE_CATEGORIE_SUCCESS,
    LISTE_CATEGORIE_LOADING,
    LISTE_CATEGORIE_ADD_MODAL,
    LISTE_CATEGORIE_ADD_LOADING,
    LISTE_CATEGORIE_UPDATE_MODAL,
    LISTE_CATEGORIE_UPDATE_LOADING
} from "../actions/types";

const initialState = {
    categories: [],
    totalRows: 0,
    totalPages: 0,
    itemDataUpdate: null,
    loading: false,
    loadingAdd: false,
    loadingUpdate: false,
    showAddModal: false,
    showUpdateModal: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case LISTE_CATEGORIE_SUCCESS:
            return {
                ...state,
                categories: payload.categories,
                totalRows: payload.totalRows,
                totalPages: payload.totalPages,
                loading: false
            };

        case LISTE_CATEGORIE_FAIL:
            return {
                ...state,
                categories: payload.message,
                loading: false
            };

        case LISTE_CATEGORIE_LOADING:
            return {
                ...state,
                // categories: payload?.loading ? [] : state.categories,
                loading: payload.loading
            };

        case LISTE_CATEGORIE_ADD_LOADING:
            return {
                ...state,
                loadingAdd: payload.loadingAdd
            };

        case LISTE_CATEGORIE_UPDATE_LOADING:
            return {
                ...state,
                loadingUpdate: payload.loadingUpdate
            };

        case LISTE_CATEGORIE_ADD_MODAL:
            return {
                ...state,
                showAddModal: payload?.show,
            };

        case LISTE_CATEGORIE_UPDATE_MODAL:
            return {
                ...state,
                showUpdateModal: payload?.show,
                itemDataUpdate: payload?.data
            };

        default:
            return state;
    }
}
